module.exports = __webpack_public_path__ + "img/bird.4a4b0193.png";